export default "__VITE_ASSET__BRr91Rft__"